import { fetchApi } from '../api/digitalVault';
import { parseFiles, parseFolders, parsePaginationManual } from '../utils';
const getFolderWithUri = async (uri, params, logger) => {
    const response = await fetchApi({ ...params, uri }, `folder/list`, {}, true, logger);
    const { folder, file, '@totalCount': total } = response.nodeCollection;
    const { hasNextPage, nextPageParams } = parsePaginationManual(params, parseInt(total));
    return {
        hasNextPage,
        data: [...parseFolders({ folder }), ...parseFiles({ file })],
        paginate: () => {
            return hasNextPage && getFolderWithUri(uri, nextPageParams, logger);
        },
    };
};
export default getFolderWithUri;
